import {ModalVideoFromImageBlock} from "@/app/parts/global/ModalVideoFromImage";

const productSlug = "singular";
const imageDirectory = `/images/${productSlug}/`;

interface ILaunchFilmCardProps {
    title: string;
    videoId: number;
}

const LaunchFilmCard = ({ title, videoId }: ILaunchFilmCardProps) => {
    const titleLowerCased = title.toLowerCase().replace(' ', '-');
    return (
        <div>
            <p className='text-center font-semibold text-sm uppercase tracking-widest mb-2.5'>{title}</p>
            <ModalVideoFromImageBlock
                imgSrc={`${imageDirectory}${titleLowerCased}-thumbnail.png`}
                imgWidth={566}
                imgHeight={317}
                imgAlt={`Thumbnail of ${title} launch film`}
                video={videoId.toString()}
                id={2}
            />
        </div>
    );
}

const SingularLaunchFilms = () => {
    const cardNames = ['Trailer', 'Product Reveal'];
    return (
        <>
            <div className='flex gap-6 w-full'>
                {cardNames.map((cardName) => (
                    <LaunchFilmCard key={`card-${cardName}`} title={cardName} videoId={0} />
                ))}
            </div>
        </>
    );
}

export default SingularLaunchFilms;